import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const DonutChart = ({ data }) => (
  <div className="flex flex-col sm:flex-row items-center gap-6">
    <ResponsiveContainer width={160} height={160}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={45}
          outerRadius={70}
          paddingAngle={3}
          dataKey="value"
        >
          {data.map((entry, i) => (
            <Cell key={i} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          formatter={(val) => [`${val}%`, ""]}
          contentStyle={{
            background: "var(--tw-bg-gray-900, #111827)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "12px",
            fontSize: "12px",
          }}
        />
      </PieChart>
    </ResponsiveContainer>
    <div className="flex flex-col gap-2">
      {data.map((item, i) => (
        <div key={i} className="flex items-center gap-2">
          <span
            className="w-2.5 h-2.5 rounded-full flex-shrink-0"
            style={{ backgroundColor: item.color }}
          />
          <span className="text-sm text-gray-600 dark:text-gray-400">
            {item.name}
          </span>
          <span className="text-sm font-semibold text-gray-900 dark:text-white ml-auto pl-4">
            {item.value}%
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default DonutChart;
